import React from 'react'
import { ConditionalNestedPipeline, Pipeline, TriggerPipelineOnClick } from '@morningtrain/react-pipelines'
import { Translation } from '@morningtrain/react-translations'
import {
  Collection,
  SubmitFormOnPipe,
  useValue, WhenCollectionIsEmpty,
  WhenCollectionIsNotEmpty,
  WhenLoaded
} from '@morningtrain/react-resources'
import * as UI from 'ui'
import SetModelOnPayloadOnPipe from 'support/pipelines/pipes/SetModelOnPayloadOnPipe'
import GetExtraFormDataPipes from 'support/pipelines/GetExtraFormDataPipes'
import { StaticFilter } from '@morningtrain/react-filters'
import * as Columns from 'support/columns'
import { Table } from 'widgets/crud'
import ListCheckbox from "support/columns/simpletons/ListCheckbox";

export default function SaveItemAction () {
  const inventoryCategoryId = useValue('inventory_category_id')

  return (
    <Pipeline>
      <TriggerPipelineOnClick>
        <UI.Button>
          <Translation name='generic.save' />
        </UI.Button>
      </TriggerPipelineOnClick>
      <SetModelOnPayloadOnPipe />
      <ConditionalNestedPipeline when='model.is_category_dirty' matches>
        <GetExtraFormDataPipes submitButton={<UI.Button text={<Translation name='generic.continue' />} />}>
          <UI.CardHeader>
            <UI.WithSubtitle subtitle={<Translation name='partials.selecting_list_will_add_to_supplier' />}>
              <UI.SecondaryHeading>
                <Translation name='titles.select_order_list' />
              </UI.SecondaryHeading>
            </UI.WithSubtitle>
          </UI.CardHeader>
          <Collection resourceName='inventory.supplier' operationName='item_suppliers'>
            <StaticFilter name='inventory_category_id' value={inventoryCategoryId} />
            <WhenCollectionIsNotEmpty>
              <Table selectMultiple>
                <ListCheckbox name='order_list_ids' keyAsValue disableHead />
                <Columns.Text name='name' />
              </Table>
            </WhenCollectionIsNotEmpty>
            <WhenLoaded>
              <WhenCollectionIsEmpty>
                <UI.Text>
                  <Translation name='partials.no_order_lists_found' />
                </UI.Text>
              </WhenCollectionIsEmpty>
            </WhenLoaded>
          </Collection>
        </GetExtraFormDataPipes>
      </ConditionalNestedPipeline>
      <SubmitFormOnPipe mergeDataFromPayload />
    </Pipeline>
  )
}
